module.exports = __webpack_public_path__ + "img/niunai5.3b831aae.jpg";